"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE_APPS = exports.APP_ICON = void 0;
const MOBILE_APPS = exports.MOBILE_APPS = 'mobile-apps';
const APP_ICON = exports.APP_ICON = 'app-icon';